// Añadido: Definir las subcolumnas para cada columna principal
export const subColsMap = {
  Sumas: ['debe', 'haber'],
  Saldos: ['deudor', 'acreedor'],
  Inventario: ['activo', 'pasivo'],
  Resultado: ['perdida', 'ganancia']
}

export const styles = {
  table: 'table-report',
  tr: 'table-report-row',
  td: 'table-report-td max-w-52 overflow-x-auto no-scrollbar',
  th: 'table-report-th text-left',
  thead: 'sticky top-0 z-10',
  tbody: 'overflow-y-auto',
  boldText: 'font-semibold',
  text: 'text-text'
}

export const orderableCols = [
  { col: 'Fecha', field: 'fecha' },
  // { col: 'Tipo', field: 'nombreTipoComprobante' },
  // { col: 'Comprobante', field: 'id' },
  // { col: 'Cuenta', field: 'nombreCuenta' },
  { col: 'Glosa', field: 'glosa' },
  { col: 'Debe', field: 'debe' },
  { col: 'Haber', field: 'haber' }
]
